const { registerBlockType } = wp.blocks;
const { RichText, MediaUpload, MediaUploadCheck, URLInputButton } =
  wp.blockEditor;
const { Button, PanelBody } = wp.components;
const { Fragment } = wp.element;
const { InspectorControls } = wp.blockEditor;
const { __ } = wp.i18n;

registerBlockType('pg/demo-section', {
  title: __('PG Software Demo Section'),
  icon: 'images-alt2',
  category: 'layout',
  supports: {
    align: true,
    html: false,
  },
  attributes: {
    title: {
      type: 'string',
      source: 'html',
      selector: '.content-wrapper h2',
    },
    description: {
      type: 'string',
      source: 'html',
      selector: '.content-wrapper div.description',
    },
    buttonText: {
      type: 'string',
      source: 'text',
      selector: '.buttons a',
      default: 'See more',
    },
    buttonUrl: {
      type: 'string',
      source: 'attribute',
      attribute: 'href',
      selector: '.buttons a',
    },
    imageUrl: {
      type: 'string',
      source: 'attribute',
      attribute: 'src',
      selector: '.image-wrapper img',
    },
    imageAlt: {
      type: 'string',
      source: 'attribute',
      attribute: 'alt',
      selector: '.image-wrapper img',
      default: '', // Ensure that the alt is non-null
    },
  },
  edit: ({ attributes, setAttributes }) => {
    const { title, description, buttonText, buttonUrl, imageUrl, imageAlt } =
      attributes;

    const onSelectImage = (media) => {
      setAttributes({
        imageUrl: media.url,
        imageAlt: media.alt || '', // Capture the alt text, set default empty string if none provided
      });
    };

    return (
      <Fragment>
        <InspectorControls>
          <PanelBody title={__('Content Settings')}>
            <p>
              <strong>{__('Manage your demo section content here.')}</strong>
            </p>
          </PanelBody>
        </InspectorControls>
        <section className="section-light-primary">
          <div className="demo-section-wrapper">
            <div className="content-container">
              <div className="content-wrapper">
                <RichText
                  tagName="h2"
                  value={title}
                  onChange={(newTitle) => setAttributes({ title: newTitle })}
                  placeholder={__('Title')}
                />
                <div className={'description'}>
                  <RichText
                    tagName={'p'}
                    value={description}
                    onChange={(newDescription) =>
                      setAttributes({ description: newDescription })
                    }
                    placeholder={__('Description')}
                  />
                </div>

                <div className="buttons">
                  <a
                    href={'#'}
                    title={buttonText}
                    className={`btn btn-dark btn-outline`}
                  >
                    <RichText
                      tagName="span"
                      value={buttonText}
                      onChange={(newText) =>
                        setAttributes({ buttonText: newText })
                      }
                      keepPlaceholderOnFocus={true}
                    />
                    <URLInputButton
                      url={buttonUrl}
                      onChange={(newUrl) =>
                        setAttributes({ buttonUrl: newUrl })
                      }
                    />
                  </a>
                </div>
              </div>
              <div className="image-wrapper relative">
                {imageUrl && (
                  <img src={imageUrl} alt={imageAlt || __('Selected image')} />
                )}
                <MediaUpload
                  onSelect={onSelectImage}
                  allowedTypes={['image']}
                  render={({ open }) => (
                    <Button onClick={open} isPrimary className={'addButton'}>
                      {__('Select Image')}
                    </Button>
                  )}
                />
              </div>
            </div>
          </div>
        </section>
      </Fragment>
    );
  },
  save: ({ attributes }) => {
    const { title, description, buttonText, buttonUrl, imageUrl, imageAlt } =
      attributes;
    return (
      <section className="section-light-primary">
        <div className="demo-section-wrapper">
          <div className="content-container">
            <div className="content-wrapper">
              <h2>{title}</h2>
              <div
                className={'description'}
                dangerouslySetInnerHTML={{ __html: description }}
              />
              <p className="buttons">
                <a href={buttonUrl} className="btn btn-dark btn-outline">
                  {buttonText}
                </a>
              </p>
            </div>
            <div className="image-wrapper">
              <img src={imageUrl} alt={imageAlt || title} />
            </div>
          </div>
        </div>
      </section>
    );
  },
});
